define('drops/calendarItem/calendarItem',[
    'jquery',
    'underscore',
    'lq/drop',
    'lq/style',
    'lq/html',
    'lq/onlongpress'
], function ($, _, Drop, Style, html, OnLongPress) {
    'use strict';

    var defaults = {
        data: {
            eventing: {
                clicked: {}
            },
            styles: {
                normal: { enabled: true },
                selected: { enabled: false }
            },
            longPressDelay: 1000,
            allowItemOverlap: true,
        }
    };

    function CalendarItem(options) {
        Drop.call(this, $('<div/>'), defaults, options);

        var self = this;

        this.$element
            .addClass('calendar-item boxToBorderSize');

        if(this.data.row && this.data.eventArg)
            this.defaultEventArg = this.data.row[this.data.eventArg];

        this.addListener('ChildAdded', function (childDrop) {
            self.applyDataToChild(childDrop);
        });

        if (!this.designData && this.isEventEnabled('onLongPress')) {
            OnLongPress.applyLongPressOnElement(this.$element, this);
        }

        Style.renderStyles(this);
    };

    Drop.extend(CalendarItem, Drop);

    CalendarItem.typeName = 'CalendarItem';

    CalendarItem.prototype.preRender = function () {
        this.applyPosition();
    };

    CalendarItem.prototype.render = function ($element) {
        return this.createAndRenderDrops($element);
    };

    CalendarItem.prototype.postRender = function () {
        if (this.data.row) {
            var tooltip = this.data.row[this.data.tooltipOutput];
            if (tooltip) this.$element.attr('title', html.strip(tooltip));
        }
    };

    CalendarItem.prototype.applyDataToChild = function (childDrop) {
        if (!this.data.row)
            return;

        childDrop.defaultEventArg = this.defaultEventArg;

        // quick hack
        var self = this;
        _.defer(function () {
            if (childDrop.setValue && _.has(self.data.row, childDrop.data.name)) {
                childDrop.setValue({
                    type: self.data.outputs[childDrop.data.name],
                    value: self.data.row[childDrop.data.name]
                });
            }

            childDrop.informListeners('DatasourceApplied', self.data.row);
        });
    };

    CalendarItem.prototype.applyPosition = function() {
        var lengthOfDay = this.data.endOfDay.diff(this.data.startOfDay, "minutes");
        var lengthOfItem = this.data.endOfItem.diff(this.data.startOfItem, 'minutes');
        var lengthToSkip = this.data.startOfItem.diff(this.data.startOfDay, 'minutes');

        var height = (100 / lengthOfDay) * lengthOfItem;
        var top = (100 / lengthOfDay) * lengthToSkip;

        this.$element
            .css({
                top: top + '%',
                height: height + '%'
            });
    };

    return CalendarItem;
});
